import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { config } from './config';
import './styles/global.css';

async function bootstrap() {
  // `import.meta.env.DEV` 在 production build 會被靜態替換成 false → MSW 整段被 tree-shake。
  if (import.meta.env.DEV && config.useMocks) {
    const { startMocks } = await import('./mocks/start');
    await startMocks();
  }

  const el = document.getElementById('root');
  if (!el) throw new Error('#root 不存在');
  createRoot(el).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void bootstrap();
